import { useEffect, useState } from "react";
import styles from "./reminder-to-become-expert.module.css";
import { useTranslation } from "react-i18next";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import { avatarProfile } from "~/assets/svg";
import ReminderCard from "./components/reminder-card/reminder-card";
import { useOutletContext } from "react-router-dom";
import { getRecommendedProducts } from "./service/reminder-to-become-expert.service";
import { RecommenderRemainder } from "./types";
import { useAnalytics, debounce } from "@commons-monorepo/index";
import {
  baseReminderPayloadEvent,
  reminderEvents } from
"~/components/reminder-to-become-expert/events";

const ReminderToBecomeExpert = () => {
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const { theme: themeContext } = useGlobalStyles();
  const { t } = useTranslation();
  const expertImg = "/prod/coupon-templates/badge-sumer.webp";
  const logoSeller = themeContext.logo || avatarProfile;
  const { storeMetadata, isMobile } = useOutletContext<any>();
  const [data, setData] = useState<RecommenderRemainder>();
  const storeOwnerId = storeMetadata?.ownerId;
  const storeName = storeMetadata?.enterpriseName;
  const timeToAppearRemainder = 1000;
  const timeToDisappearRemainder = 7000;
  const [logEvent] = useAnalytics({ storeMetadata });

  const handleOpen = () => {
    const timer = setTimeout(() => {
      setIsAlertVisible(true);
      logEvent(reminderEvents.view_screen, {
        ...baseReminderPayloadEvent,
        event_subtype: "own_domain_loader"
      });
    }, timeToAppearRemainder);

    const debounceFunction = debounce(() => {
      setIsAlertVisible(false);
      clearTimeout(timer);
    }, timeToDisappearRemainder);
    debounceFunction();
  };

  const handleClose = () => {
    logEvent(reminderEvents.select_button, {
      ...baseReminderPayloadEvent,
      event_subtype: "own_domain_loader_finish"
    });
    setIsAlertVisible(false);
  };

  const dataReminder = async () => {
    try {
      const dataRemainderProducts = await getRecommendedProducts(storeOwnerId);
      setData(dataRemainderProducts);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dataReminder();
    handleOpen();
  }, []);

  return (
    <>
      {isAlertVisible &&
      <div className={styles.wrapper}>
          <div className={styles.container}>
            <div className={styles.texts}>
              <img src={logoSeller} alt='logo' className={styles.logo} />
              <h4 className={styles.title}>
                {t("reminderToBecomeExpert.title")} {storeName}{" "}
                {t("reminderToBecomeExpert.next_title")}
              </h4>
              <button className={styles.button} onClick={handleClose}>
                {t("reminderToBecomeExpert.button")}
              </button>
            </div>
            <div className={styles.productBox}>
              <div className={styles.expertBox}>
                <img
                src={expertImg}
                alt='expert'
                className={styles.productImg} />

                <h3 className={styles.description}>
                  {t("reminderToBecomeExpert.description")}
                </h3>
              </div>
              {!!data?.recommenderProductStores?.length &&
            <div className={styles.grid}>
                  {data?.recommenderProductStores?.
              slice(0, isMobile ? 1 : undefined).
              map((item, index) =>
              <ReminderCard
                onClick={() => {
                  logEvent(reminderEvents.select_button, {
                    ...baseReminderPayloadEvent,
                    event_subtype: "own_domain_loader_item",
                    source: item.productId
                  });
                }}
                productName={item.name}
                image={item.image}
                price={item.unitPrice}
                ownerId={item.ownerId}
                productId={item.productId} />

              )}
                </div>}

            </div>
          </div>
        </div>}

    </>);

};

export default ReminderToBecomeExpert;